/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Desktop_TitleInputs */

const en_mk_desktop_title = /** @type {(inputs: Mk_Desktop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your computer, connected to Bystep.`)
};

const id_mk_desktop_title = /** @type {(inputs: Mk_Desktop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komputermu, terhubung ke Bystep.`)
};

/**
* | output |
* | --- |
* | "Your computer, connected to Bystep." |
*
* @param {Mk_Desktop_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_desktop_title = /** @type {((inputs?: Mk_Desktop_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Desktop_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_desktop_title(inputs)
	return en_mk_desktop_title(inputs)
});